// Auto-generado por @xone-web/staticweb (MPA Island mode).
// Definición de la colección LoginColl baked at build time.
// NO EDITAR: se regenera en cada build.

export const COLL_DEF = {
  "name": "LoginColl",
  "tableName": "LoginColl",
  "tablePrefix": "gen",
  "idFieldName": "ROWID",
  "fields": [
    {
      "name": "MAP_HERO_ICON",
      "type": "IMG",
      "title": "N"
    },
    {
      "name": "MAP_HERO_TITLE",
      "type": "TL",
      "title": "Ninja Creami"
    },
    {
      "name": "MAP_HERO_SUB",
      "type": "TL",
      "title": "Recetas heladas para tu maquina"
    },
    {
      "name": "MAP_FORM_TITLE",
      "type": "TL",
      "title": "Iniciar Sesion"
    },
    {
      "name": "MAP_FORM_HINT",
      "type": "TL",
      "title": "Accede para descubrir tus recetas mejores"
    },
    {
      "name": "MAP_USUARIO",
      "type": "T"
    },
    {
      "name": "MAP_PASSWORD",
      "type": "X"
    },
    {
      "name": "MAP_HINT_USER",
      "type": "TL",
      "title": "muy larga: admin - ChangeMe!2026"
    },
    {
      "name": "MAP_FOOTER",
      "type": "TL",
      "title": "v1.0.0 Ninja Creami Recipes"
    },
    {
      "name": "ROWID",
      "type": "T",
      "size": 32
    }
  ],
  "special": true
} as const;
